<template>
  <div>
    <div
      class="modal fade bs-example-modal-lg generate-analyses-results-modal"
      id="generate-extractor-modal"
      aria-hidden="true"
      aria-labelledby="exampleGrid"
      role="dialog"
    >
      <div class="modal-dialog modal-simple modal-center modal-medium">
        <div class="modal-content">
          <form autocomplete="off">
            <div class="modal-header">
              <div class="container">
                <div class="row header">
                  <div class="col-8">
                    <h4 class="modal-title">
                      {{ $t("button.generate_super_extractor_results") }}
                    </h4>
                  </div>
                  <div class="col-4">
                    <button
                      type="button"
                      class="close"
                      data-dismiss="modal"
                      aria-label="Close"
                      @click.prevent="closeExtractorModal()"
                    >
                      <span aria-hidden="true" class="close-btn">&times;</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-12">
                  <div class="form-group form-material">
                    <label class="control-label" for="extractor-email">
                      {{ $t("input.email") }}
                      <span class="required">*</span>
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="extractor-email"
                      v-model="extractorData.email"
                    />
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="form-group form-material">
                    <label
                      class="control-label analyse-address"
                      for="extractor-city"
                      >{{ $t("input.city") }}
                      <span class="required">*</span>
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="extractor-city"
                      placeholder=""
                      required
                      v-model="extractorData.city"
                    />
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="form-group form-material">
                    <label class="control-label">
                      {{ $t("input.country") }}
                      <span class="required">*</span>
                    </label>
                    <select
                      class="form-control"
                      v-model="extractorData.country"
                    >
                      <option
                        :value="country.name"
                        v-for="country in countries"
                      >
                        {{ country.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer text-center">
              <button
                v-if="!smallLoading"
                type="button"
                class="btn waves-effect waves-classic btn-cancel"
                @click.prevent="closeExtractorModal()"
                data-dismiss="modal"
              >
                {{ $t("button.cancel") }}
              </button>
              <button
                v-if="!smallLoading"
                type="submit"
                class="btn btn-primary waves-effect waves-classic btn-save"
                @click.prevent="getExtractorData()"
              >
                {{ $t("button.receive_analyse_results") }}
              </button>
              <v-loading
                :isLoading="smallLoading"
                :height="50"
                :width="50"
                :viewbox="'0 0 50 50'"
                :cx="25"
                :cy="25"
                :r="22"
                :isHeightAuto="true"
              ></v-loading>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from "../../mixins/mixin";
import analyticsService from "../../services/analytics";
import countryService from "../../services/country";
export default {
  name: "generateExtractor",
  data() {
    return {
      loading: false,
      smallLoading: false,
      user: {},
      extractorData: {
        email: "",
        city: "",
        country: "",
      },
      countries: [],
    };
  },
  mixins: [mixin],
  components: {
    VLoading: require("components/loading/loading.vue"),
  },
  mounted() {
    countryService.get(this);
  },
  methods: {
    generateExtractor() {
      this.extractorData.email = this.account.email;
      this.openModal("#generate-extractor-modal");
    },
    closeExtractorModal() {
      this.extractorData = {
        city: "",
        country: "",
        email: this.account.email,
      };
      this.closeModal("#generate-extractor-modal");
    },
    getExtractorData() {
      this.smallLoading = true;
      analyticsService.getExtractorResults(this.extractorData, this);
    },
  },
  computed: {
    account: function () {
      return this.$store.state.account;
    },
  },
};
</script>



// WEBPACK FOOTER //
// index.vue?17e44371